import axios from "axios"
import { call, put } from "redux-saga/effects"
import { IQuickSightAction,IClearQuickSightAction } from "../actions/quickSight"
import { getToken } from "../authentication"

export type Store_QuickSightUrl = {
  type: "STORE_QUICKSIGHTURL",
  payload: {
    quickSightUrl: string
  }
}

export type Clear_QuickSightUrl = {
  type: "CLEAR_QUICKSIGHT_URL",
}

export type TAlertsTrendData = {
  searchOptions: string
}

export function* getQuickSightUrl(params: IQuickSightAction) {
  try {
    const data: string = yield call(getQuickSightEmbedUrl, params)
    yield put({
      type: "STORE_QUICKSIGHTURL",
      payload: {
        quickSightUrl: data
      }
    } as Store_QuickSightUrl)
  } catch (error) {
    console.log("get quicksight url error", error)
  }
}

export async function getQuickSightEmbedUrl(params: IQuickSightAction) {
  const tokenRes = await getToken();
  const response = await axios.post(process.env.REACT_APP_WEBAPPAPI + '/quicksight',
    {
      dashboardId: params.payload.dashboardId,
      org_id: params.payload.org_id
    }, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": tokenRes.token!
      }
  }
  )
  return response.data?.data?.body.EmbedUrl as string
}

export function* clearQuickSightUrl(params: IClearQuickSightAction) {
  try {
    yield put({
      type: "CLEAR_QUICKSIGHT_URL"
    } as Clear_QuickSightUrl)
  } catch (error) {
  }
}